import React from "react";
import { Card, CardBody } from "reactstrap";
import GlobalContext from "../../../../../../../Context/GlobalContext";
import { NavLink } from "react-router-dom";
import "./PackvideoCard.css";
import { useTranslation } from "react-i18next";

export default function PackvideoCard({ packvideo }) {
  const { setSelectedSubsId } = React.useContext(GlobalContext); // Appel du hook en dehors du bloc conditionnel
  const { t } = useTranslation();
  if (!packvideo) return null; // Condition de rendu après l'appel du hook

  const {   price, token_amount, id } = packvideo;



 

  const handleEnSavoirPlusClick = () => {
    setSelectedSubsId(id);
  };

  return (
    <div className="packVideo-card parent-container">
      <Card style={{ width: "18rem" }} className="h-100 card-jeton">
        <CardBody
          className="card-body-jeton"
        >
          {/*  <CardTitle tag="h5" style={{ color: "#ffffff", textAlign: "center" }}>
          <b>{name}</b>
        </CardTitle> */}
          <div
            className="packvideo-details"
          >
            <h3
              className="plan-price padding-b-15"
              style={{ color: "#4AAE9B", fontWeight: 400 }}
            >
              {Math.floor(price)} €
            </h3>
            <p
              className="token-amount"
              style={{
                color: "#2E2E2E",
                fontSize: "18px",
                textAlign: "center",
              }}
            >
              {token_amount} {t("tokens")}
            </p>
          </div>

          {/* <CardSubtitle
          className="mb-2"
          tag="h6"
          style={{
            color: "#ffffff",
            textAlign: "left",
            padding: "30px 0 20px 0",
            fontSize: "14px"
          }}
        >
          {descriptionArray.map((line, index) => (
            <React.Fragment key={index}>
              <span style={{ color: "#ffffff" }}>✔</span>
              {line.trim()}
              <br />
            </React.Fragment>
          ))}
        </CardSubtitle> */}

        </CardBody>
        <center>
          <NavLink
            to={`/public/pack/g/${id}`}
            className="btn btn-sm acheter"
            onClick={handleEnSavoirPlusClick}
          >
            {t("buyButton")}
          </NavLink>
        </center>
      </Card>
    </div>
  );
}
